
export const DISPATCH_ORDER= 'DISPATCH_ORDER'
export const DISPATCH_ORDER_SUCCESS= 'DISPATCH_ORDER_SUCCESS'
export const DISPATCH_ORDER_ERROR='DISPATCH_ORDER_ERROR'


export const DispatchOrder= (data) => ({
    type: DISPATCH_ORDER,
    payload: data
});